import { z } from "zod";

/**
 * Allowance Period is a singleton — GET + PUT only, no create/delete. This is
 * the only mutation shape that exists (no `createAllowancePeriodSchema`).
 */

// What the edit form collects — all fields required (it always edits the one
// existing row, never partially).
export const allowancePeriodFormSchema = z.object({
  periodStart: z.iso.date(),
  periodEnd: z.iso.date(),
  totalAllowanceHours: z.number().min(0, "Allowance cannot be negative"),
});
export type AllowancePeriodFormValues = z.infer<typeof allowancePeriodFormSchema>;

// What the API's PUT accepts — every field optional (partial update).
export const updateAllowancePeriodSchema = allowancePeriodFormSchema.partial();
export type UpdateAllowancePeriodInput = z.infer<typeof updateAllowancePeriodSchema>;
